import React, { useEffect } from "react";
import { Button } from "framework7-react";

interface IbuttonProps {
  btnText?: string; // set button text which is conditional
  btnId?: any; // set button id which is conditional
  btnClass?: any; // set button class
  children?: any; // set any control which is conditional
  popupOpen?: string; // set for open popup which is conditional
  popupClose? : boolean; // set for close popup which is conditional
  handleChangeValue?: (any) ; // set onclick event
  outline?: boolean; // button property which is conditional
  round?: boolean; // button property which is conditional
  disabled?:boolean; // button property to disable it
  color?:string; // button property to display color
  isFill?:boolean; //check when true then fill attribute for button otherwise not supported
  style?:any;//set style which apply dynamic
  modelName?: any;
  modelId?:string;
  ariaLabel?: string; // accessible name forwarded to the underlying button for screen readers
  href?: any; // underlying anchor href; pass false to render a non-focusable button (ADA)
  nextFocusElementId?: string; // ADA: id of the element to move focus to on Enter/Tab
  isDisableBtn?: boolean; // ADA: when true, skip moving focus to nextFocusElementId on Enter
  role?: string; // ADA: override the implicit role (F7 renders an <a>; pass "button" so AT announces a button, not a link)
}

const Ybutton: React.FC<IbuttonProps> = ({
  children,
  btnText,
  btnId,
  btnClass,
  handleChangeValue,
  outline,
  popupClose,
  round,
  disabled,
  color,
  popupOpen,
  isFill,
  style,
  modelName,
  modelId,
  ariaLabel,
  href,
  nextFocusElementId,
  isDisableBtn,
  role
}) => {

  // A button is "disabled" for screen readers if the disabled prop is set OR it carries the
  // visual-disabled class (btn-disbled) used across the app. aria-disabled => NVDA reads "unavailable".
  const isAriaDisabled = disabled || /btn-dis(b|ab)led/.test(String(btnClass || "")) || undefined;

  useEffect(() => {
    if (btnId) {
      let lastElement = document.getElementById(btnId) as any;
      if (lastElement) {
        if (lastElement.addEventListener) {
          lastElement.addEventListener('keydown', onKeyDownOpenPopup, false);
        }
      }
    }
  }, [btnId])

  const onKeyDownOpenPopup = (e) => {
    if (e.keyCode === 13) {
      let mainModel;
      if (modelId) {
        mainModel = document.querySelector(`#${modelId}`) as any
      }
      else {
        mainModel = document.querySelector(`.${modelName}`) as any
      }
      if (nextFocusElementId && !isDisableBtn) {
        let focusElement = document.getElementById(nextFocusElementId) as any;
        if (focusElement) {
          setTimeout(() => {
            focusElement.focus();
          }, 500);
        }
      } else {
        let focusedElement = mainModel?.getElementsByTagName("a") as any;
        if (focusedElement) {
          setTimeout(() => {
            focusedElement[0]?.focus();
          }, 500);
        }
      }
    }
    if (e.keyCode === 9 && !e.shiftKey) {
      if (btnId === "Get-Report") {
        let mainModel = document.getElementsByClassName("themeFooter") as any;
        if (mainModel) {
          let focusedElement = mainModel[0]?.getElementsByClassName("smallText") as any;
          if (focusedElement) {
            setTimeout(() => {
              focusedElement[0]?.focus();
            }, 0);
          }
        }
      } else if (btnId === "addEmailNextBtn") {
        let backBtnDiv = document.querySelector('div.backBtn[id="General"]')?.querySelector('a.btn-green') as any;
        if (backBtnDiv) {
          setTimeout(() => {
            backBtnDiv.setAttribute("tabIndex", "0");
            backBtnDiv?.focus();
          }, 0);
        }
      }
      else if (nextFocusElementId) {
        let focusElement = document.getElementById(nextFocusElementId) as any; // for Add vehicle main screen
        if (focusElement) {
          setTimeout(() => {
            focusElement.focus();
          }, 0);
        }
      }
    }
  }

  return (
    isFill ? (<Button id={btnId} fill color={color} outline={outline} round={round} popupClose={popupClose} popupOpen={popupOpen} className={btnClass} onClick={handleChangeValue} disabled={disabled} style={style} aria-label={ariaLabel} aria-disabled={isAriaDisabled} {...(role ? { role } : {}) as any} href={href}>
      {btnText}
      {children}
    </Button>) : (<Button id={btnId} type="text" className={btnClass ? "themeBtn " + btnClass : "themeBtn"} color={color} outline={outline} round={round} popupClose={popupClose} popupOpen={popupOpen} onClick={handleChangeValue} disabled={disabled} style={style} aria-label={ariaLabel} aria-disabled={isAriaDisabled} {...(role ? { role } : {}) as any} href={href}>
      {btnText}
      {children}
    </Button>)

  );
};

export default Ybutton;
